// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"339":"494496f6","403":"e80f0243","542":"c84c01a5","629":"3c99ad5f","640":"19e331de","879":"1bf2d290"}[chunkId] + ".chunk.js";
};